import app from '../app.first';
import $ from 'jquery';

app.ModulesForm = class extends app.Component {
	onReady() {
        this.$el.on('submit', e => {

            var button = this.$el.find('[type="submit"]');

                button.attr('disabled', true);
                    setTimeout(function(){ button.removeAttr("disabled") }, 2000);
        });
    }
}